export default __webpack_public_path__ + "static/media/gs-5.f38f4326.png";